import axios from 'axios';
import store from '../store';
export default {
  namespaced: true,

  state: {
    idmodal: '',
    descripcionmodal: '',
    banderamodal: null,
    lineas: [],
    linea: [],


  },
  mutations: {
    LoadProductos(state, buscar) {
      //let aux = [];
      state.linea = state.lineas;


      let aux = state.lineas.filter((x) => x["nombrelinea"].toUpperCase().includes(buscar.toUpperCase()),);

      if (buscar == "") {
        state.linea = state.lineas;
      } else {
        state.linea = aux;

      }
    },



    async cargardatoslineas(state) {

      state.lineas = []
      var token = store.state.numero;
      await axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Lineas", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.lineas = response.data.data;

        });
      state.linea = state.lineas
    },

    cambio(state, descripcion) {
      state.descripcionmodal = descripcion

    },
    agregartable(state) {

      //      this.descripcionmodal = descripcion
      var token = store.state.numero;
      var datos = {
        nombrelinea: state.descripcionmodal
      };
      this.banderamodal = store.state.banderamodal



      var datosfalso = state.idmodal;

      if (this.banderamodal === true) {


        axios

          .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Lineas", datos, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          })
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;


          })

          .catch((e) => {
            console.log(e);
          });
      } else {

        axios

          .post(
            "https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Lineas/UpdateReg/" +
            datosfalso,
            datos,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
            }
          )
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;

          })

          .catch((e) => {
            console.log(e);
          });
      }

    },


    datosmodal(state, api) {

      state.idmodal = api.idlinea,
        state.descripcionmodal = api.nombrelinea

    },



    async eliminar(state, api) {
      var token = store.state.numero
      let eliminar = api;


      await axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Lineas/DeleteReg/" + eliminar,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          })


        .then((response) => {
          let tokenn = response.data.token;
          state.datoeliminar = tokenn

        })

        .catch((e) => {
          console.log(e);
        });



    },



  },
  actions: {

  },
  getters: {


  },






}